<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              {{ $t("reward.title_give_point") }}
            </div>
          </div>
          <div class="box-body">
            <div class="box-form-wrap">
              <div class="col-md-6 col-sm-6">
                <div class="form-group">
                  <label for="customer" style="align-self: center">
                    {{ $t("reward.from_customer") }}
                  </label>
                  <div>
                    <b-form-select
                      v-model="sendPoint.current_customer"
                      class="form-control"
                      @change="changePoint($event)"
                    >
                      <option
                        v-for="(customer, index) in CustomerList"
                        :key="index"
                        v-bind:value="customer.value"
                      >
                        {{ customer.text }}
                      </option>
                    </b-form-select>
                  </div>
                </div>
                <!-- so diem muon tangs -->
                <div class="form-group">
                  <label for="customer" style="align-self: center">
                    {{ $t("reward.no_want_give") }}
                  </label>
                  <div>
                    <b-form-input
                      type="number"
                      v-model="sendPoint.num_reward_point"
                      min="0"
                      :max="sendPoint.number_of_point"
                      required
                      class="form-control"
                      id="number_want_to_give"
                    />
                  </div>
                </div>

                <!-- email nguoi nhan -->
                <div class="form-group">
                  <label for="customer" style="align-self: center">
                    {{ $t("reward.receiver_email") }}
                  </label>
                  <div>
                    <b-form-input
                      v-model="sendPoint.received_email"
                      class="form-control"
                      id="receive_email"
                    />
                  </div>
                </div>

                <!-- noi dunbg -->
                <div class="form-group">
                  <label for="customer" style="align-self: center">
                    {{ $t("reward.content") }}
                  </label>
                  <div>
                    <b-form-input
                      v-model="sendPoint.content"
                      class="form-control"
                      id="content"
                    />
                  </div>
                </div>
              </div>

              <!-- sfsdfas rfawef -->
              <div
                class="col-md-6 col-sm-6"
                style="display: flex;
                       justify-content: center;"
              >
                <div style="position:relative">
                  <i class="fa fa-certificate star-custom" aria-hidden="true">
                  </i>
                  <span class="star-text">
                    <div>
                      <h3 style="color: red;font-weight: bold;">
                        {{ sendPoint.number_of_point }}
                      </h3>
                      <h4 style="font-weight: bold;">
                        {{ $t("reward.point") }}
                      </h4>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="box-footer">
            <button
              type="button"
              class="btn btn-labeled btn-danger"
              @click="onCancel"
              style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
            >
              <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
              {{ $t("common.back") }}
            </button>

            <button
              type="button"
              class="btn btn-labeled btn-success pull-right"
              style="margin-right: 5px;"
              @click="onSave"
            >
              <span class="btn-label"> <i class="fa fa-star"></i> </span>
              {{ $t("reward.givePoint") }}
            </button>
          </div>
        </div>
      </row>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import loading from "vue-loading-overlay";
// import utils from '@/lib/utils'

export default {
  name: "CustomerGiveRewardPoint",
  data() {
    return {
      sendPoint: {
        current_customer: 4,
        num_reward_point: 0,
        received_email: "",
        content: "",
        number_of_point: 0
      },
      CustomerList: [],
      isLoading: false,
      pre_params: null,
      pre_query: {}
    };
  },
  watch: {
    GET_CUSTOMER_DATA_REWARD_POINT: function() {
      this.CustomerList = [];
      this.GET_CUSTOMER_DATA_REWARD_POINT.forEach(customer => {
        let text = customer.last_name + " " + customer.first_name;
        let data = {
          value: customer.id,
          text: text
        };
        this.CustomerList.push(data);
      });
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_CUSTOMER_DATA_REWARD_POINT",
      "UPDATE_CUSTOMER_DATA",
      "GET_ACCOUNT_DATA",
      "GET_REWARD_POINT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_CUSTOMER_LIST_REWARD_POINT",
      "SEND_MAIL_REWARD_POINT"
    ]),
    changePoint(id) {
      this.GET_CUSTOMER_DATA_REWARD_POINT.forEach(customer => {
        if (customer.id == id) {
          this.sendPoint.number_of_point = customer.reward_point;
        }
      });
    },
    onCancel: function() {
      this.$router.push({
        name: "CustomerAdd",
        params: {
          id: this.pre_params
        },
        query: {
          is_company: this.pre_query.is_company,
          callback: this.pre_query.callback
        }
      });
    },
    onSave: function() {
      if (
        parseInt(this.sendPoint.num_reward_point) >
        parseInt(this.sendPoint.number_of_point)
      ) {
        this.ON_SHOW_TOAST({
          message: this.$t("reward.not_enough_reward_point"),
          styleType: "danger"
        });
        return;
      }
      if (this.sendPoint.num_reward_point == 0) {
        this.ON_SHOW_TOAST({
          message: this.$t("reward.kindly_import_reward_point"),
          styleType: "danger"
        });
        return;
      }
      let data = {
        giver: this.sendPoint.current_customer,
        point: this.sendPoint.num_reward_point,
        receiver: this.sendPoint.received_email,
        content: this.sendPoint.content
      };
      this.isLoading = true;
      this.SEND_MAIL_REWARD_POINT(data)
        .then(
          function() {
            this.isLoading = false;
            this.SUCCESS_TOAST();
            this.$router.push({
              name: "CustomerAdd",
              params: {
                id: this.pre_params
              },
              query: {
                is_company: this.pre_query.is_company,
                callback: this.pre_query.callback
              }
            });
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            if (
              error.response.data.message == "Không tìm thấy email người nhận"
            ) {
              this.ON_SHOW_TOAST({
                message: this.$t("reward.not_found_receiver_email"),
                styleType: "danger"
              });
            } else {
              this.ERROR_TOAST();
            }
          }.bind(this)
        );
    }
  },
  mounted() {
    this.sendPoint.current_customer = this.$route.query.current_customer;
    this.pre_params = this.$route.query.params_id;
    this.pre_query = this.$route.query.query_link;
    this.sendPoint.number_of_point = this.$route.query.reward_point;

    this.isLoading = true;
    this.GET_CUSTOMER_LIST_REWARD_POINT();
  },
  components: {
    loading: loading,
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<style>
.star-custom {
  font-size: 20rem;
  color: white;
  text-shadow: 2px 0 0 orange, -2px 0 0 orange, 0 2px 0 orange, 0 -2px 0 orange,
    1px 1px orange, -1px -1px 0 orange, 1px -1px 0 orange, -1px 1px 0 orange;
}
.star-text {
  position: absolute;
  right: 34px;
  top: 52px;
  text-align: center;
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/Customer/CustomerGiveRewardPoint.vue